export const filterGroupsList: string[] = ['alert', 'error', 'transaction'];
